export const samples = [
  {
    title: 'Feelings & Self-Regulation',
    label: 'Unit 01 · Opening page',
    image: 'https://cdn.magicpatterns.com/uploads/kypcWfsECHKtvgUY4RkKkr/01_portada.png',
  },
  {
    title: 'What Might They Feel?',
    label: 'Student worksheet',
    image: 'https://cdn.magicpatterns.com/uploads/w8UR6v2jFCWo2rzBEkHE2b/02_que_sienten.png',
  },
  {
    title: 'A Character’s Body Clues',
    label: 'Student worksheet',
    image: 'https://cdn.magicpatterns.com/uploads/m3uNSXTxC7uPBawR9HPK61/03_pistas_del_cuerpo.png',
  },
  {
    title: 'Build Your Calm Toolbox',
    label: 'Lesson 04 · Strategy cards',
    image: 'https://cdn.magicpatterns.com/uploads/2xX34HHNxDgyWSyPWuHXzv/04_tarjetas_calma.png',
  },
  {
    title: 'My Feelings Action Plan',
    label: 'Lesson 06 · Scenario cards',
    image: 'https://cdn.magicpatterns.com/uploads/oHy2NwT2dsd9AAHQmti83u/05_tarjetas_escenarios.png',
  },
];
